var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.value.can_delete)?_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require("@/assets/delete_bin.svg")},on:{"click":_vm.handleClick}}):_c('img',{attrs:{"src":require("@/assets/delete_bin_disabled.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }